"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const Box_1 = __importDefault(require("@mui/material/Box"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "EqualHeights";
exports.classes = {
    contentBox: `${PREFIX}-contentBox`
};
exports.Root = (0, styles_1.styled)(Box_1.default)({
    [`&.${exports.classes.contentBox}`]: {
        boxSizing: "content-box"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VxdWFsLWhlaWdodHMvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDREQUFvQztBQUNwQyxpREFBOEM7QUFFOUMsTUFBTSxNQUFNLEdBQUcsY0FBYyxDQUFDO0FBQ2pCLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLFVBQVUsRUFBRSxHQUFHLE1BQU0sYUFBYTtDQUNuQyxDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsYUFBRyxDQUFDLENBQUM7SUFDOUIsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxVQUFVLEVBQUUsQ0FBQyxFQUFFO1FBQzNCLFNBQVMsRUFBRSxhQUFhO0tBQ3pCO0NBQ0YsQ0FBQyxDQUFDIn0=